<template>
  <el-dialog :visible.sync="visible" custom-class="work-shift-dialog" width="min(520px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.workShiftId" class="title-actions">
        <el-button v-if="isAuth('base:workShift:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:workShift:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="100px">
      <el-form-item label="班次编码" prop="shiftCode"><el-input v-model="form.shiftCode" :disabled="readonly" /></el-form-item>
      <el-form-item label="班次名称" prop="shiftName"><el-input v-model="form.shiftName" :disabled="readonly" /></el-form-item>
      <el-form-item label="适用车间">
        <el-select v-model="form.workShopId" clearable filterable placeholder="空=全厂" style="width:100%" :disabled="readonly">
          <el-option v-for="item in shops" :key="item.workShopId" :label="item.workShopName" :value="item.workShopId" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-time-picker v-model="form.startTime" format="HH:mm" value-format="HH:mm" placeholder="请选择开始时间" style="width:100%" :disabled="readonly" />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-time-picker v-model="form.endTime" format="HH:mm" value-format="HH:mm" placeholder="请选择结束时间" style="width:100%" :disabled="readonly" />
      </el-form-item>
      <el-form-item label="排序"><el-input-number v-model="form.lineSort" :min="0" :precision="0" style="width:100%" :disabled="readonly" /></el-form-item>
      <el-form-item label="启用">
        <el-radio-group v-model="form.isenabled" :disabled="readonly"><el-radio label="0">启用</el-radio><el-radio label="1">禁用</el-radio></el-radio-group>
      </el-form-item>
      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :disabled="readonly" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'WorkShiftAddOrUpdate',
  data() {
    return {
      visible: false, readonly: false, shops: [], form: this.blank(), permCodes: [],
      rules: {
        shiftCode: [{ required: true, message: '班次编码不能为空', trigger: 'blur' }],
        shiftName: [{ required: true, message: '班次名称不能为空', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看班次'
      return this.form.workShiftId ? '修改班次' : '新增班次'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    blank() { return { workShiftId: '', shiftCode: '', shiftName: '', workShopId: '', startTime: '', endTime: '', lineSort: 0, isenabled: '0', remark: '' } },
    loadShops() { request.post('/base/workShop/list', { currentPage: 1, pageSize: 500 }).then(res => { this.shops = (res.data && res.data.list) || [] }).catch(() => {}) },
    init(id, readonly, defaults) {
      this.visible = true
      this.readonly = !!readonly
      this.loadShops()
      if (!id) {
        this.form = Object.assign(this.blank(), defaults || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/production/workShift/info', { params: { id } }).then(res => {
        const row = res.data || {}
        this.form = {
          ...this.blank(),
          ...row,
          lineSort: row.lineSort == null ? 0 : Number(row.lineSort),
          workShopId: row.workShopId || ''
        }
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = this.blank(); this.readonly = false },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (this.form.startTime === this.form.endTime) {
          this.$message.error('班次开始和结束时间不能相同')
          return
        }
        request.post('/production/workShift/save', this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        request.post('/production/workShift/delete', { workShiftId: this.form.workShiftId }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>

<style>
.work-shift-dialog { margin-top: 12px !important; max-height: calc(100vh - 24px); display: flex; flex-direction: column; }
.work-shift-dialog .el-dialog__body { min-height: 0; overflow-y: auto; }
.work-shift-dialog .el-dialog__header, .work-shift-dialog .el-dialog__footer { flex-shrink: 0; }
</style>
